/**
 * @param {Date} date1
 * @param {Date} date2
 * @returns {*|boolean}
 */
export default function isEqualDate(date1, date2) {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
}
